<app-grid-template [columns]="columns" [urlString]="urlString" (action)="action($event)"></app-grid-template>

<button mat-raised-button>BACK</button>